<div class="clause-variance-analysis" [formGroup]="form">
  <div class="clause-variance-analysis__title">
    {{ 'workspaces.clauseVarianceAnalysis' | transloco }}
  </div>
  <div class="clause-variance-analysis__subtitle">
    {{ 'workspaces.auditYourDocumentLibrary' | transloco }}
  </div>

  <div class="row">
    <div class="col-md-3 control-label">
      {{ 'workspaces.referenceDocument' | transloco }}
    </div>
    <div class="col">
      <app-single-select-autocomplete
        class="w100"
        formControlName="referenceDocument"
        [autocompleteOptions]="workspaceDocuments"
        optionLabel="name"
        optionValue="id"
        (onSelect)="onReferenceDocumentSelect($event)"
      ></app-single-select-autocomplete>
    </div>
  </div>

  @if (workspaceDocuments.length < 2) {
    <div class="row">
      <div class="col clause-variance-analysis__error">
        {{ 'workspaces.clauseVarianceAnalysisError' | transloco }}
      </div>
    </div>
  }

  <div class="clause-variance-analysis__actions">
    <!-- Button hidden because the feature is not available yet  -->
    <!-- 
    <app-button
      [type]="btnTypes.Stroked"
      [size]="btnSizes.Basic"
      [label]="'workspaces.generateReport' | transloco"
      [disabled]="!selectedReferenceDocument || workspaceDocuments.length < 2"
      (onClick)="generateReport()"
    ></app-button> 
    -->
    <app-button
      [type]="btnTypes.Flat"
      [size]="btnSizes.Basic"
      [label]="'workspaces.launchAnalysis' | transloco"
      [disabled]="!canLaunchAnalysis || !selectedReferenceDocument || workspaceDocuments.length < 2"
      (onClick)="launchAnalysis()"
    ></app-button>
  </div>
</div>
